import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import CopilotFre from '@office-start/copilot-fre';
import { CopilotFreStatus, UserCopilotFreData } from '@office-start/copilot-fre-service';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import { UserEntitlements } from '@office-start/user-entitlements-types';
import * as React from 'react';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';

import ReactRenderer from '../shared/react/react-renderer';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Component({
    selector: 'ohp-copilot-fre',
    template: ''
 })
export class CopilotFreComponent extends ReactRenderer implements OnInit, OnDestroy {

    @Input() public userEntitlements: UserEntitlements;
    @Input() public userCopilotFreData: UserCopilotFreData;
    @Input() public onFreCompleted: (copilotFreStatus: CopilotFreStatus) => void;

    constructor(
        elementRef: ElementRef,
        capabilitiesService: CapabilitiesService,
        clientStartupConfigService: ClientStartupConfigService,
        contextService: ContextService
    ) {
        super(elementRef);
        initializeFluentIcons(capabilitiesService, contextService, clientStartupConfigService);
    }

    public ngOnInit () {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        if (!React) {
            return null;
        }

        return (
            <OfficeFluentProvider>
                <CopilotFre
                    onCopilotFreCompleted={this.onFreCompleted}
                    userEntitlements={this.userEntitlements}
                    userPinningData={this.userCopilotFreData} />
            </OfficeFluentProvider>
        );
    }
}
